import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import cogoToast from 'cogo-toast';

/**
 * Custom hook for handling risk config saves with custom update logic
 * @param {Function} updatePromise - Promise-based update function (e.g., updateBinaryOptionDiscretionaryAddOnPromise)
 * @param {Function} fetchAction - Action to refresh data after update
 * @param {Function} transformChange - Function to transform a change object into the payload
 * @returns {Function} Save handler that can be passed to RiskConfigTable's onSaveOverride prop
 */
export const useCustomRiskConfigSave = (updatePromise, fetchAction, transformChange) => {
  const dispatch = useDispatch();

  return useCallback(
    async (changes) => {
      try {
        const { update } = changes;
        if (!isEmpty(update)) {
          // Send all updates in a single batch request
          const payload = transformChange(update);
          await updatePromise(payload, dispatch);
          // Refresh the data after successful update
          dispatch(fetchAction({}));
        }
      } catch (e) {
        cogoToast.error(e.message || 'Could not apply changes');
      }
    },
    [dispatch, updatePromise, fetchAction, transformChange],
  );
};
